import React from 'react';
import { useSelector } from 'react-redux';
import { css } from '@emotion/core';
import FontScaleDiv from 'client/components/FontScaleDiv';

function CommentSettings({ settings = {}, result, isFixed, isResult = false }) {
    const { isSmallScreenApp } = useSelector(s => s.appState);
    const {
        value,
        settings: { colorBackGround, colorBorder, colorMask, colorText, mode } = {}
    } = settings;

    const toGiveBackground = type => {
        if (type === 'image') {
            return value;
        } else if (type === 'color') {
            return colorBackGround;
        }
    };

    return (
        <div
            css={[
                showBackgroundUrlStyle(colorMask, toGiveBackground(mode), isResult),
                mode === 'color' && showBackgroundColorStyle(colorBackGround),
                !isFixed &&
                    css`
                        min-height: 150px;
                        flex-direction: column;
                    `
            ]}
        >
            <div
                css={[
                    showTextStyle(colorText, colorBorder, isResult),
                    !isFixed && noFixedTextStyle
                ]}
            >
                {isFixed ? (
                    <FontScaleDiv
                        maxFontSize={isSmallScreenApp ? 34 : 60}
                        rowLimit={isSmallScreenApp ? 4.7 : 8}
                        content={result}
                        style={{
                            textAlign: 'center'
                        }}
                    />
                ) : (
                    result
                )}
            </div>
        </div>
    );
}

export default CommentSettings;

const showBackgroundUrlStyle = (backgroundColor, background, isResult) => css`
    background: linear-gradient(0deg, ${backgroundColor}, ${backgroundColor}), url(${background});
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    &:hover {
        > .NO_CLOSE_PANEL_CLASS_NAME {
            opacity: 1;
        }
    }
    border-radius: ${isResult && '0px 24px 24px 24px;'};
`;
const showBackgroundColorStyle = backgroundColor => css`
    background: ${backgroundColor};
`;
const showTextStyle = (textColor, borderColor, isResult) => css`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Noto Sans TC';
    font-weight: 500;
    font-size: 44px;
    line-height: 64px;
    text-align: left;
    letter-spacing: 0.15px;
    color: ${textColor};
    border: 1px solid ${borderColor};
    padding: 8px;
    overflow: hidden;
    border-radius: ${isResult && '0px 24px 24px 24px;'};
    word-break: break-word;
    word-wrap: break-word;
`;
const noFixedTextStyle = css`
    align-items: start;
    flex: 0.9;
    font-size: 20px;
    line-height: 29px;
    letter-spacing: 0.15px;
    justify-content: start;
`;
